import { Card } from "@/components/ui/card";
import { EmptyState } from "@/components/ui/EmptyState";
import { Database } from "lucide-react";

export const DataPreview = () => (
  <Card className="p-6">
    <h2 className="text-lg font-semibold mb-4">Data Preview</h2>
    <EmptyState
      icon={Database}
      title="No data sources connected"
      description="Connect a CRM or upload a file to see live data here."
      actionLabel="Go to Integrations"
      actionHref="/data"
    />
  </Card>
);
